import * as qs from 'qs';
import { useLocation, useNavigate } from 'react-router';

import type { DialogKey } from 'components/navigation/WithDialogs';
import { getSafePreviousLocation } from 'lib/navigation/getSafePreviousLocation';

export const useCloseDialog = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return (dialogKey: DialogKey, otherParams?: string[], force?: boolean) => {
    const searchParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    delete searchParams[dialogKey];
    otherParams?.forEach(param => {
      delete searchParams[param];
    });
    if (force) {
      navigate(
        `${location.pathname}${qs.stringify(searchParams, {
          addQueryPrefix: true,
        })}`,
        {
          replace: true,
          preventScrollReset: true,
        }
      );
      return;
    }
    navigate(
      getSafePreviousLocation(
        `${location.pathname}${qs.stringify(searchParams, {
          addQueryPrefix: true,
        })}`
      ),
      {
        replace: true,
        preventScrollReset: true,
      }
    );
  };
};
